module.exports = __webpack_public_path__ + "static/media/ColtriLogo.29e095f2.png";